/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-01-10 11:13:31
 * @LastEditors: linxi
 * @LastEditTime: 2025-06-24 15:03:59
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Modal, notification } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectInsuranceArray } from '../../app/applicationSlice'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import { searchCategory, setSelectId } from '../commodity/commoditySlice'
import { setTargetId } from '../examinetreat/examinetreatSlice'
import { ExamineModal } from '../examinetreat/modal'
import { Columns } from './columns'
import { EditCatalogueModal } from './editCatalogueModal'
import { getDirectoryChangeList, getOverlookAsync } from './HomeSlice'

interface DetailsOfDirectoryChangesModalProps {
  content?: any
  messageId?: any
  visible: boolean
  onOk: () => void
  onCancel: () => void
}

export const DetailsOfDirectoryChangesModal = ({
  content,
  messageId,
  visible,
  onOk,
  onCancel,
}: DetailsOfDirectoryChangesModalProps) => {
  const dispatch = useDispatch<RootDispatch>()

  const insuranceArray = useSelector(selectInsuranceArray)

  const [loading, setLoading] = useState(false)

  const [info, setInfo] = useState<any>()

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [categoryList, setCategoryList] = useState<any>() //类别数据

  const [IsModalVisible, setIsModalVisible] = useState<any>(false)

  const [IsExamineModalVisible, setIsExamineModalVisible] = useState<any>(false)

  const [medicalType, setMedicalType] = useState<any>(0)

  const [mappingId, setMappingId] = useState<any>()

  const [hilistCode, setHilistCode] = useState<any>()

  const [billingCategory, setBillingCategory] = useState<any>()

  const [insuranceItem, setInsuranceItem] = useState<any>()

  useEffect(() => {
    if (insuranceArray.length) {
      setInsuranceItem(insuranceArray[0])
    }
  }, [insuranceArray])

  useEffect(() => {
    if (visible) {
      getList()
    }
  }, [visible, params])

  const getList = () => {
    setLoading(true)
    dispatch(getDirectoryChangeList({ ...params, changeDate: content }))
      .then(unwrapResult)
      .then((v: any) => {
        setPage({
          total: v?.total,
          items: v?.records,
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    //获取类别分类
    if (visible)
      dispatch(searchCategory())
        .then(unwrapResult)
        .then((res) => {
          setCategoryList([
            {
              name: '全部',
              id: '1234567894562',
            },
            ...res,
          ])
        })
  }, [visible])

  const getOverlookState = (data: any) => {
    dispatch(getOverlookAsync({ ...data }))
      .then(unwrapResult)
      .then((v) => {
        if (data?.status == 2) {
          notification.success({
            message: '操作成功',
          })
        }
        getList()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <>
      <Modal
        title={'已匹配的医保目录变动详情'}
        width={1200}
        visible={visible}
        onCancel={onCancel}
        onOk={onOk}
        footer={null}
        destroyOnClose
        maskClosable={false}
      >
        <EditableList
          style={{ height: '460px', overflow: 'hidden' }}
          bordered
          loading={loading}
          scroll={{ y: 400 }}
          sticky
          rowKey={(v, i) => {
            return `${i}`
          }}
          page={{
            current: params.current,
            size: params.size,
            total: page.total,
            items: page.items,
          }}
          columns={Columns(params.size * (params.current - 1), (action, t) => {
            if (action == 'editCatalogue') {
              const data = {
                changeDate: t?.changeDate,
                materialsCatalogId: t?.materialsCatalogId,
                medicalType: t?.medicalType,
                status: 1,
                messageId: messageId,
              }
              // getOverlookState(data)
              // 1:药品 2:诊疗 3:耗材
              // 诊疗
              if (t?.medicalType == 2) {
                dispatch(setTargetId(t?.materialsCatalogId))
                setInfo({ ...t, ...insuranceItem })
                setIsExamineModalVisible(true)
              } else {
                setMappingId(t?.mappingId)
                setHilistCode(t?.hilistCode)
                setBillingCategory(t?.billingCategory)
                setMedicalType(t?.medicalType)
                dispatch(setSelectId(t?.materialsCatalogId))
                setIsModalVisible(true)
              }
            } else if (action == 'overlook') {
              const data = {
                changeDate: t?.changeDate,
                materialsCatalogId: t?.materialsCatalogId,
                medicalType: t?.medicalType,
                status: 2,
                messageId: messageId,
              }
              setLoading(true)
              getOverlookState(data)
            }
          })}
          onChangePage={(current, size) =>
            setParams({
              ...params,
              current,
              size: size || 10,
            })
          }
        />
      </Modal>
      <EditCatalogueModal
        billingCategory={billingCategory}
        hilistCode={hilistCode}
        mappingId={mappingId}
        medicalType={medicalType}
        isModalVisible={IsModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
          getList()
          setMappingId('')
          setHilistCode('')
          setBillingCategory('')
          setMedicalType(0)
        }}
        onOk={() => {
          setIsModalVisible(false)
          getList()
          setMappingId('')
          setHilistCode('')
          setBillingCategory('')
          setMedicalType(0)
        }}
      ></EditCatalogueModal>
      <ExamineModal
        info={info}
        categoryList={categoryList}
        visible={IsExamineModalVisible}
        onCancel={() => {
          setIsExamineModalVisible(false)
          getList()
        }}
        onOk={() => {
          setIsExamineModalVisible(false)
          getList()
        }}
      />
    </>
  )
}
